
import {group, mapValues, objectify, sort, sum} from "radash";
import {obervationTypeById, questionnaire} from "../metaDataProcessed";


const buildView = (state, visibleSectionLabel, selectedObservationTypeId) => {

    const metaData = questionnaire

    const rounds = state.rounds
    const observations = state.observations

    const observationsByTypeId =
        group(observations, o => o.observation_type_id)

    const notesByObservationTypeId = group(state.round_notes, n => n.observation_type_id)

    function* trav(row, depth, level0Label, level1Label) {

        for (const childRow of row.children) {
            switch (depth) {
                case 0:
                    if (visibleSectionLabel === childRow.label) {
                        yield* trav(childRow, depth + 1, childRow.label)
                    }
                    break
                case 1:
                    yield* trav(childRow, depth + 1, level0Label, childRow.label)
                    break
                case 2:

                    const observationTypeIdsInCategory =
                        objectify(childRow.children, r => r.id, () => true)

                    const observationCount = sum(state.observations.map(
                        o => observationTypeIdsInCategory[o.observation_type_id] ? 1 : 0
                    ))

                    yield {
                        depth,
                        type: 'SubSubSection',
                        o: childRow,
                        label: childRow.label,
                        level0Label,
                        level1Label,
                        roundObservations: rounds.map(v => ({round: v})),
                        isCategory: true,
                        isvisibleCategoryId: state.visibleCategoryId === childRow.id,
                        observationTypeIdsInCategory,
                        observationCount
                    }
                    yield* trav(childRow, depth + 1)
                    break
                case 3:

                    if(state.visibleCategoryId !== row.id) {
                        break
                    }

                    const observationsOfType = observationsByTypeId[childRow.id]

                    const observationsForRound = round_id => {
                        if (!observationsOfType) {
                            return null
                        }

                        return sort(
                            observationsOfType.filter(o => round_id === o.round_id),
                            o => o.id
                        )
                    }

                    const notesForThisO = notesByObservationTypeId[childRow.id] || []

                    const obsRow = {
                        depth,
                        type: 'Observations',
                        o: childRow,
                        label: childRow.name,
                        parentLabel: row.label,
                        roundObservations: rounds.map(round => {
                            return {
                                round: round,
                                observation_type_id: childRow.id,
                                observations: observationsForRound(round.id),
                            }
                        }),
                        roundNotes: rounds.map(round => {
                            return {
                                round: round,
                                note: notesForThisO.find(note => note.round_id === round.id)
                            }
                        })
                    }

                    if (obsRow.o.id === selectedObservationTypeId) {
                        yield {
                            depth: 0,
                            type: 'SelectedObservationTypePanel',
                            o: obsRow
                        }
                    }
                    else {
                        yield obsRow
                    }
                    break
                default:
                    throw Error(`should not have gotten here ${depth} ${childRow}`)
            }
        }
    }

    return [...trav(metaData, 0, visibleSectionLabel)]
}

export const healthOverviewReducer = (state, action) => {


    const countObservationsPerTab = observations =>
        mapValues(
            group(
                observations.map(o => obervationTypeById[o.observation_type_id].tab),
                    i => i
            ),
            v => v.length || null
        )


    switch (action.name) {
        case "init": {

            const rounds = action.dossier.rounds
            const observations = action.dossier.observations
            const round_notes = action.dossier.round_notes

            return {
                visibleSectionLabel: null,
                observations,
                rounds,
                round_notes,
                rows: buildView({observations, rounds, round_notes}, null, null),
                observationCountPerTab: countObservationsPerTab(observations),
                viewedTabForLastRound: {"Vasculite": true},
                visibleCategoryId: null
            }
        }
        case "setVisibleSection":

            const rows = buildView(state, action.visibleSectionLabel)

            return {
                ...state,
                visibleSectionLabel: action.visibleSectionLabel,
                selectedObservationType: null,
                rows,
                viewedTabForLastRound: {...state.viewedTabForLastRound, [action.visibleSectionLabel]: true}
            }
        case "toggleVisibleCategory": {

            const newState = {
                ...state,
                visibleCategoryId: action.categoryId
            }

            return {
                ...newState,
                rows: buildView(newState, newState.visibleSectionLabel, action.observation_type_id)
            }
        }
        case "newObservation": {

            const newState = {
                ...state,
                observations: [...state.observations, {
                    id: action.new_id,
                    round_id: action.round.id,
                    observation_type_id: action.observation_type_id,
                    fields: action.fields,
                    last_update: action.last_update
                }]
            }
            return {
                ...newState,
                rows: buildView(newState, newState.visibleSectionLabel, action.observation_type_id),
                observationCountPerTab: countObservationsPerTab(newState.observations)
            }
        }
        case "deleteObservation": {

            const newState = {
                ...state,
                selectedObservationType: action.observation_type_id,
                observations: state.observations.filter(o => {
                    return o.id !== action.observation_round_id
                })
            }

            return {
                ...newState,
                rows: buildView(newState, newState.visibleSectionLabel, action.observation_type_id)
            }
        }
        case "updateObservationFields": {
                const newState = {
                    ...state,
                    observations: state.observations.map(o => {
                        if(o.id === action.observation_round_id) {
                            return {
                                ...o,
                                fields: action.fields,
                                last_update: action.last_update
                            }
                        }
                        return o
                    })
                }

                return {
                    ...newState,
                    rows: buildView(newState, newState.visibleSectionLabel, action.observation_type_id)
                }
            }
        case "updateObservationNote": {

            const newState = {
                ...state,
                round_notes: Object.values({
                    ...objectify(state.round_notes, n => n.id, n => n),
                    [action.observation_round_note.id]: action.observation_round_note
                })
            }

            return {
                ...newState,
                rows: buildView(newState, newState.visibleSectionLabel, action.observation_type_id)
            }
        }
        case "selectObservationType": {
            return {
                ...state,
                selectedObservationType: action.observation_type_id,
                rows: buildView(state, state.visibleSectionLabel, action.observation_type_id)
            }
        }
        default:
            throw Error(`unknown action ${name}`)
    }
}

